import React, { Component } from 'react';
import { ModalHeader, ModalBody, ModalFooter, Col, Row, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { FROM_DATE, TO_DATE, PARTIAL_FAILURE, PROCESSING, PENDING } from '../constant';
import './style.scss';
import Preloader from '../../../../components/UI/Preloader/index';
class TransactionReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: null,
            fromDate: null,
            transactionFile: null
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.uploadFlag !== prevProps.uploadFlag) {
            if (this.props.uploadFlag) {
                this.setState({
                    toDate: null,
                    fromDate: null,
                    transactionFile: null,
                })
            }
        }
    }
    onChangeDate = (date, type) => {
        switch (type) {
            case FROM_DATE:
                this.setState({
                    fromDate: date
                })
                break;
            case TO_DATE:
                this.setState({
                    toDate: date
                })
                break;
            default:
        }
    }
    uploadExcel = (event) => {
        this.setState({
            transactionFile: event.target.files[0]
        },() => {
            document.getElementById('file').value = null
        })
    }
    handleUpload = () => {
        this.props.transactionReportCallback({
            corporateId: this.props.corporateData.id,
            file: this.state.transactionFile,
            fromDate: moment(this.state.fromDate).format('YYYY-MM-DD'),
            toDate: moment(this.state.toDate).format('YYYY-MM-DD')
        })
    }
    render() {
        return (
            <React.Fragment>
                <ModalHeader className="modal-header-title" toggle={this.props.toggleModal}>{this.props.corporateData.corporateName}</ModalHeader>
                <ModalBody className="payment-modal-body">
                    <div className="transaction-report px-0">
                        {
                            this.props.transactionData.map((p, index) => {
                                return (<Row key={index} className="font-size-13 color-888 p-2 align-items-center">
                                    <Col sm='10'>{moment(p.fromDate).format("Do MMM YYYY")} to {moment(p.toDate).format("Do MMM YYYY")}</Col>
                                    <Col sm='5'>{moment(p.createdAt).format("Do MMM YYYY")}</Col>
                                    <Col sm='9' className="d-flex justify-content-between align-items-center">
                                        <Button color="link"
                                            className={`btn btn-opacity mr-3 ${(p.status === PARTIAL_FAILURE)
                                                ? 'btn-opacity-danger text-danger download-link'
                                                : (p.status === PROCESSING || p.status === PENDING)
                                                    ? 'text-warning btn-opacity-warning download-link'
                                                    : 'text-success btn-opacity-success download-link'}`
                                            }
                                            onClick={() => this.props.handleDownloadCallback(p)}>
                                            {p.status}
                                        </Button>
                                        <div className="pr-3"><i className="icon-close pointer" onClick={() => this.props.deleteTransactionCallback(p)} /></div>
                                    </Col>
                                </Row>
                                )
                            })
                        }
                    </div>
                </ModalBody>
                <ModalFooter style={{ display: 'inline', borderTop: 'none', padding: '0' }}>
                    <Row className="footer-content mb-4 pb-3">
                        <Col xs='12'>
                            <Row className="text-muted">Submission Date Range</Row>
                            <Row>
                                <Col sm='12' className='date-input'>
                                    <DatePicker className="form-control datepicker-label" popperPlacement='top' popperModifiers={{
                                        offset: {
                                            enabled: true,
                                            offset: '20px, 10px, 10px, 0px'
                                        }
                                    }} name="From Date" onChange={(date) => this.onChangeDate(date, FROM_DATE)} dateFormat="dd-MM-yyyy" selected={(this.state.fromDate) ? moment(this.state.fromDate) : null} placeholderText='From DD-MM-YYYY' />
                                </Col>
                                <Col sm='12' className='date-input'>
                                    <DatePicker className="form-control datepicker-label" popperPlacement='top' popperModifiers={{
                                        offset: {
                                            enabled: true,
                                            offset: '20px, 10px'
                                        }
                                    }} onChange={(date) => this.onChangeDate(date, TO_DATE)} dateFormat="dd-MM-yyyy" selected={(this.state.toDate) ? moment(this.state.toDate) : null} placeholderText='To DD-MM-YYYY' />
                                </Col>
                            </Row>
                        </Col>
                        <Col xs='8'>
                            <Row className="text-muted ml-1">Excel Sheet Uploader</Row>
                            <Row color="primary" className="btn btn-primary ml-0 position-relative upload-payment-data" title="Upload New Risk Factor">
                                {/* <div> */}
                                <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Upload New Risk Factor" />
                                <i className="fa fa-paperclip color-888 rotate-90deg p-1" /> &nbsp;Browse File(s)
                            </Row>
                            <Row className="text-muted ml-1">{(this.state.transactionFile) ? this.state.transactionFile.name : ''}</Row>
                        </Col>
                        <Col xs="4">
                            <div className="text-muted pb-2">Action</div>
                            <Button color="primary" className="btn" onClick={this.handleUpload}>Upload</Button>

                        </Col>
                    </Row>
                    <Row className="mb-4">
                        <Col className="download-template-text" xs="24"><span className="download-template" onClick={() => this.props.downloadTemplateCallback(this.props.corporateData)} >Click here</span> to download the template</Col>
                    </Row>
                    <Row>
                        {this.props.transactionDataErrors.map((p, index) =>
                            <div className="text-danger" key={p}>{index + 1}- {p}</div>
                        )}
                    </Row>
                    {/* <Button color="secondary" onClick={this.props.toggleModal}>Close</Button>
                    <Button color="primary" onClick={this.handleRedirect}>View changes</Button> */}
                </ModalFooter>
                <Preloader></Preloader>
            </React.Fragment>
        )
    }
}
export default TransactionReport